export enum TenantSignupTrigger {
    Disabled = 'disabled',
    SignupChatStart = 'signup_chat_start',
    SignupLoadComments = 'signup_load_comments',
    SubscribeChatStart = 'subscribe_chat_start',
}
